import { render } from "./About.vue?vue&type=template&id=7fc8820a&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=7fc8820a&scoped=true&lang=css"
/* custom blocks */
import block0 from "./About.vue?vue&type=custom&index=0&blockType=transition&name=fade"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc8820a"]])

export default __exports__